/** @module components/drag-and-drop-quiz */


import {DropArea, DropAreaInitialState, DropAreaView} from './DropArea';

import {LabelledDropArea as labelledDropAreaTemplate} from '../../templates/drag-and-drop-quiz';


/**
 * Specifies the initial state for a [[LabelledDropArea]].
 */
export interface LabelledDropAreaInitialState extends DropAreaInitialState {

    /**
     * Sets the label that should be rendered for the drop area.
     */
    label: string;
}


/**
 * A [[DropArea]] that includes a label.
 */
export class LabelledDropArea extends DropArea {

    /**
     * Gets the label that should be rendered for the drop area.
     */
    public readonly label: string;

    /**
     * Initializes a new instance of the [[LabelledDropArea]] class.
     *
     * @param initialState Specifies the initial state for the new instance.
     * @param data An optional object to be passed through to the base class' ([[Model]]) constructor.
     */
    public constructor(initialState: LabelledDropAreaInitialState, data?: object) {
        super(initialState, data);
    }
}


export class LabelledDropAreaView extends DropAreaView {

    public constructor() {
        super(labelledDropAreaTemplate);
    }
}
